import React from 'react';

export default function VideoModal({ id, src }) {
  // build iframe an append it to the reveal with the given id
  function appendIframeToReveal() {
    const videoContainer = document.querySelectorAll(`#${id} .video-responsive`)[0];

    if (videoContainer) {
      const hasCookiebot = typeof Cookiebot !== 'undefined';
      const isVimeo = src.indexOf('vimeo.com') !== -1;

      if (!hasCookiebot || !isVimeo || (isVimeo && hasCookiebot && Cookiebot.consent.statistics)) {
        // load iframe if there is no Cookiebot, if the video is not from vimeo
        // or if the video is from vimeo and the statistics cookies are accepted
        const iframe = document.createElement('iframe');
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('src', src);

        videoContainer.innerHTML = '';
        videoContainer.appendChild(iframe);
      } else {
        const paragraph = document.createElement('p');
        paragraph.innerHTML = `
        Bitte <a href="javascript: Cookiebot.renew()">Statistiken-Cookies akzeptieren</a>
        und die Seite neuladen, um Videos von Vimeo an der Stelle anzeigen zu können.
        `;
        paragraph.classList = 'padding-md color-white';

        videoContainer.innerHTML = '';
        videoContainer.appendChild(paragraph);
      }
    }
  }

  return (
    <div className="reveal-modal" id={id}>
      <div className="video-responsive" data-embed={src} onClick={appendIframeToReveal}></div>
      <a className="close-reveal-modal">&#215;</a>
    </div>
  );
}

VideoModal.propTypes = {
  id: React.PropTypes.string,
  src: React.PropTypes.string
};



// WEBPACK FOOTER //
// ./components/videos/videoModal.js